import type { Editor } from 'hugerte';

export const filePickerCallback =
	(editorRef: React.RefObject<Editor | null>) =>
	(cb: (uri: string) => void): void => {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');

		input.onchange = () => {
			const file = input.files?.[0];
			if (!file) return;

			const reader = new FileReader();

			reader.onload = (_e) => {
				// reader.result should be a string due to use of reader.readAsDataURL()
				if (!reader.result || typeof reader.result !== 'string' || !editorRef.current) return;
				const id = `blobid${new Date().getTime()}`;
				const { blobCache } = editorRef.current.editorUpload;
				const base64 = reader.result.split(',')[1];
				if (base64 === undefined) return;
				const blobInfo = blobCache.create(id, file, base64);
				blobCache.add(blobInfo);
				cb(blobInfo.blobUri());
			};

			reader.readAsDataURL(file);
		};

		// safari requires that input be added to document
		input.setAttribute('style', 'margin-left:-1000px');
		// Prevent React Aria from marking this element inert when inside a modal
		input.setAttribute('data-react-aria-top-layer', 'true');
		document.body.appendChild(input);
		input.click();
	};
